import { useEffect, useMemo, useState } from 'react'

const storage = typeof window !== 'undefined' ? window.localStorage : undefined

export const createPersitedKey = (family, key) => `#${family}:${key}`

export const getPersistedItem = (key) => {
  const value = storage.getItem(key)
  if (value) {
    return JSON.parse(value)
  }
}

export const setPersistedItem = (key, value) => {
  value = JSON.stringify(value)
  if (value !== undefined) {
    return storage.setItem(key, value)
  } else {
    removePersistedItem(key)
  }
}

export const removePersistedItem = (key) => {
  return storage.removeItem(key)
}

export const usePersistedStorage = (persistedKey, defaultValue) => {
  const getValue = () => {
    if (persistedKey) {
      const savedValue = getPersistedItem(persistedKey)
      return savedValue ?? defaultValue
    } else {
      return defaultValue
    }
  }

  const [value, setValue] = useState(getValue)

  useEffect(() => {
    const newValue = getValue()
    if (newValue !== value) {
      queueMicrotask(() => {
        setValue(newValue)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [persistedKey])

  useEffect(() => {
    if (!persistedKey) return
    setPersistedItem(persistedKey, value)
  }, [value, persistedKey])

  return useMemo(() => [value, setValue], [value])
}
